import React from "react";
import cx from "classnames";

type Props = {
  label: string;
  style?: any;
} & React.InputHTMLAttributes<HTMLInputElement>;

const Label: React.FC<Props> = ({ label, style, className }): JSX.Element => {
  return (
    <div
      className={cx("flex flex-row justify-center font-nunito", className)}
      style={style}
    >
      {label}
    </div>
  );
};

export default Label;
